











































import { Component, mixins } from '@niknevis/vue-modules'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'
import DialogMixin from '@/modules/common/dialog/mixins/DialogMixin'
import { Prop } from 'vue-property-decorator'

@Component({
  components: { BaseButton }
})
export default class DeleteConfirm extends mixins<DialogMixin>(DialogMixin) {
  @Prop({ default: 'حذف یک مورد' }) readonly title!: string
  @Prop({ default: 'آیا از حذف این آیتم اطمینان دارید ؟' }) readonly message!: string
  @Prop({ default: 'حذف' }) readonly confirmBtnLabel!: string
  @Prop({ default: 'انصراف' }) cancelBtnLabel !: string

}
